import React from "react";
import { Link } from "react-router-dom";
import { posts } from "../blog/posts";
import { Header } from "../components/Header";

const BlogList: React.FC = () => {
    return (
        <>
            <Header />
            <div className="min-h-screen px-6 py-24 bg-white">
                <div className="max-w-3xl mx-auto">
                    <h1 className="text-4xl font-display font-bold text-gray-800 mb-10 text-center">
                        Blog
                    </h1>
                    <ul className="space-y-8">
                        {posts.map((post) => (
                            <li key={post.slug} className="p-6 border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-shadow">
                                <Link to={`/blog/${post.slug}`} className="block">
                                    <h2 className="text-2xl font-semibold text-brand-primary mb-2">
                                        {post.title}
                                    </h2>
                                    <p className="text-sm text-gray-500 mb-4">{post.date}</p>
                                    <p className="text-gray-700">{post.excerpt}</p>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </>
    );
};

export default BlogList; 